import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import { PAIS_TELEFONO_POR_DEFECTO } from './telefono-validacion.util';

export function normalizarEmailContacto(email: string | null | undefined): string {
  return (email?.trim() ?? '').toLowerCase();
}

export function normalizarTelefonoContacto(
  telefono: string | null | undefined,
  paisPorDefecto: CountryCode = PAIS_TELEFONO_POR_DEFECTO
): string {
  const raw = telefono?.trim() ?? '';
  if (!raw) {
    return '';
  }

  const parsed = raw.startsWith('+')
    ? parsePhoneNumberFromString(raw)
    : parsePhoneNumberFromString(raw, paisPorDefecto);

  if (parsed?.isValid()) {
    return parsed.number;
  }

  return raw.replace(/\s+/g, '');
}

export function hayValoresDuplicados(valores: string[]): boolean {
  const vistos = new Set<string>();
  for (const valor of valores) {
    if (!valor) {
      continue;
    }
    if (vistos.has(valor)) {
      return true;
    }
    vistos.add(valor);
  }
  return false;
}

export function firmantesTienenEmailDuplicado(
  firmantes: Array<{ email?: string | null }>
): boolean {
  const emails = firmantes
    .map(firmante => normalizarEmailContacto(firmante.email))
    .filter(email => email.length > 0);
  return hayValoresDuplicados(emails);
}

export function firmantesTienenTelefonoDuplicado(
  firmantes: Array<{ telefono?: string | null }>
): boolean {
  const telefonos = firmantes
    .map(firmante => normalizarTelefonoContacto(firmante.telefono))
    .filter(telefono => telefono.length > 0);
  return hayValoresDuplicados(telefonos);
}

function valoresDuplicados(valores: string[]): Set<string> {
  const vistos = new Set<string>();
  const duplicados = new Set<string>();
  for (const valor of valores) {
    if (!valor) {
      continue;
    }
    if (vistos.has(valor)) {
      duplicados.add(valor);
    } else {
      vistos.add(valor);
    }
  }
  return duplicados;
}

export function codigosConEmailDuplicado(
  firmantes: Array<{ codigo: string; email?: string | null }>
): string[] {
  const emailsNorm = firmantes.map(firmante => normalizarEmailContacto(firmante.email));
  const duplicados = valoresDuplicados(emailsNorm);
  return firmantes
    .filter((_, index) => duplicados.has(emailsNorm[index]))
    .map(firmante => firmante.codigo);
}

export function codigosConTelefonoDuplicado(
  firmantes: Array<{ codigo: string; telefono?: string | null }>
): string[] {
  const telefonosNorm = firmantes.map(firmante => normalizarTelefonoContacto(firmante.telefono));
  const duplicados = valoresDuplicados(telefonosNorm);
  return firmantes
    .filter((_, index) => duplicados.has(telefonosNorm[index]))
    .map(firmante => firmante.codigo);
}
